unit uStudentTest;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ComCtrls, WEBLib.REST, WEBLib.JSON, System.NetEncoding, WEBLib.Buttons,
  WEBLib.WebCtrls;

type
  TfStudentTest = class(TForm)
    lblInfo: TLabel;
    pbProgress: TProgressBar;
    chkA: TCheckBox;
    chkB: TCheckBox;
    chkC: TCheckBox;
    chkD: TCheckBox;
    chkE: TCheckBox;
    chkF: TCheckBox;
    chkG: TCheckBox;
    chkH: TCheckBox;
    btnUkoncit: TSpeedButton;
    btnDalsia: TSpeedButton;
    btnZavriet: TSpeedButton;
    lblA: THTMLDiv;
    lblB: THTMLDiv;
    lblC: THTMLDiv;
    lblD: THTMLDiv;
    lblE: THTMLDiv;
    lblF: THTMLDiv;
    lblG: THTMLDiv;
    lblH: THTMLDiv;
    memOtazka: THTMLDiv;
    [async]
    procedure btnDalsiaClick(Sender: TObject); async;
    [async]
    procedure btnUkoncitClick(Sender: TObject); async;
    procedure btnZavrietClick(Sender: TObject);
  private
    { Private declarations }
    FTestID: Integer;            // Pridaj toto
    FAktualnePoradie: Integer;    // Pridaj toto
    FPismenaPozicii: array[0..7] of string;

    FChybneOtazky: TStringList; // Sem si schováme IDčka zlých otázok
    FOprakLenChyby: Boolean;    // Príznak, či práve beží opravné kolo

  public
    { Public declarations }
    FMaxOtazok: Integer;          // Pridaj toto
    textChyb     : string;
   [async]
   procedure OtvorTest(ATestID, APoradie: Integer); async;
   procedure NaplnCheckBox(ACheckBox: TCheckBox; AData: TJSONObject);
   procedure VycistiOdpovedovePole;
   [async]
   procedure ZavriTestNaPozadi; async;
  protected procedure LoadDFMValues; override; end;

var
  fStudentTest: TfStudentTest;

implementation

{$R *.dfm}

uses uVysledkyTestu, Hlavny;


procedure PriradOdpoved(ALabel: THTMLDiv; const ACisloOtazky, APismeno, AText: String);
var
  imgUrl: String;
begin
  imgUrl := 'img/' + ACisloOtazky + '_' + LowerCase(APismeno) + '.jpg';
  // 🚀 JEDEN JEDINÝ UNIVERZÁLNY RIADOK PRE VŠETKY OTÁZKY:
  // Ak obrázok chýba (chyba 404), onerror tam podstrčí 1px priehľadný GIF
  // a študent uvidí iba čistý text odpovede bez rozbitej ikony!
  ALabel.HTML.Text := '<img src="' + imgUrl + '" onerror="this.src=''data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'';" style="vertical-align:middle; max-height:40px; margin-right:10px;" /> ' + AText;
end;

procedure PriradOtazku(AMemo: THTMLDiv; const ACisloOtazky, ATextOtazky: String);
var
  imgUrl: String;
begin
  // Vzorec v zadaní otázky sa bude vždy volať napr. 'img/668_otazka.jpg'
  imgUrl := 'img/' + ACisloOtazky + '_otazka.jpg';
  // 🚀 UNIVERZÁLNY ZÁPIS: Ak obrázok na disku chýba, podhodí sa 1px GIF a zostane len čistý text zadania!
  AMemo.HTML.Text := '<img src="' + imgUrl + '" onerror="this.src=''data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'';" style="display:block; margin: 10px 0; max-height:80px;" /><br />' + ATextOtazky;
end;


{
procedure PriradOdpoved(ALabel: TWebHTMLDiv; const ACisloOtazky, APismeno, AText: String);
var
  imgUrl: String;
begin


  // 🚀 JEDNODUCHÁ PASCAL PODMIENKA:
  // Ak je číslo otázky '641' (alebo neskôr pridáme ďalšie čísla grafických otázok),
  // vieme na 100 %, že k nej existujú vyrezané obrázky na disku.
  if (ACisloOtazky = '641') then
  begin
    imgUrl := 'img/' + ACisloOtazky + '_' + LowerCase(APismeno) + '.jpg';
    ALabel.HTML.Text := '<img src="' + imgUrl + '" style="vertical-align:middle; max-height:40px; margin-right:10px;" /> ' + AText;
  end
  else
  begin
    // Pre všetky bežné výpočtové a textové otázky (ako 640) priradíme len čistý text.
    // Tým pádom sa web vôbec nepokúša hľadať súbor a žiadna rozbitá ikona nevznikne!
    ALabel.HTML.Text := AText;
  end;
end;
             }




procedure TfStudentTest.OtvorTest(ATestID, APoradie: Integer);
var
  wr: THttpRequest;
  res: TJSXMLHttpRequest;
  CistyJsonText, FilterPayload: string;
  // Čisté Delphi web objekty pre bezpečnú prácu s JSON
  JSONRes, JSONOdpoved: TJSONObject;
  JSONArrayOdpovede: TJSONArray;
  IDOtazky, SurovyTextOdpovede, SurovePismeno: string;
  I: Integer;
begin
  FTestID := ATestID;
  FAktualnePoradie := APoradie;
  FilterPayload := '{"TEST_ID":' + IntToStr(FTestID) + ',"PORADIE":' + IntToStr(FAktualnePoradie) + '}';
  wr := THttpRequest.Create(nil);
  try
    wr.Command := httpPOST;
    wr.URL := 'http://' + window.location.hostname + ':8080/vytiahniotazku';
    // 🔒 Jediný legitímny asm blok slúži výhradne na Base64 zakódovanie payloadu
    asm
      var utf8Bytes = encodeURIComponent(FilterPayload).replace(/%([0-9A-F]{2})/g, function(match, p1) {
          return String.fromCharCode('0x' + p1);
      });
      wr.FPostData = btoa(utf8Bytes);
    end;
    // Asynchrónne počkáme na odpoveď zo servera cez overený Perform dopyt
    res := await(TJSXMLHttpRequest, wr.Perform);
    if (res <> nil) and (res.responseText <> '') then
    begin
      // 🔓 Dešifrovanie z Base64 do čistého slovenského UTF-8 reťazca
      asm
        var cleanResponse = res.responseText.replace(/[\r\n\s]/g, '');
        var binaryString = atob(cleanResponse);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        var decoder = new TextDecoder('utf-8');
        CistyJsonText = decoder.decode(bytes);
      end;
      // 🛑 1. DIAGNOSTICKÉ OKNO: Ukáže nám, či server vôbec poslal validný JSON text
//      ShowMessage('Dáta úspešne dešifrované! Surový JSON text: ' + CistyJsonText);
      VycistiOdpovedovePole;
      JSONRes := TJSONObject.ParseJSONValue(CistyJsonText) as TJSONObject;
      try
        if JSONRes <> nil then
        begin
          FMaxOtazok := StrToInt(JSONRes.Get('max_otazok').JsonValue.Value);
          lblInfo.Caption := Format('Otázka %d z %d', [FAktualnePoradie, FMaxOtazok]);
          pbProgress.Position := Round((FAktualnePoradie / FMaxOtazok) * 100);

//          PriradOtazku(memOtazka, IDOtazky, JSONRes.Get('text_otazky').JsonValue.Value);

          memOtazka.HTML.Text := JSONRes.Get('text_otazky').JsonValue.Value;

          IDOtazky := JSONRes.Get('id_otazky').JsonValue.Value;

          JSONArrayOdpovede := JSONRes.Get('odpovede').JsonValue as TJSONArray;
          if JSONArrayOdpovede <> nil then
          begin
            // 🛑 2. DIAGNOSTICKÉ OKNO: Overíme, koľko odpovedí napočítal Pascal framework
//            ShowMessage('Pascal úspešne načítal pole odpovedí. Počet nájdených riadkov: ' + IntToStr(JSONArrayOdpovede.Count));
            for I := 0 to JSONArrayOdpovede.Count - 1 do
            begin
              JSONOdpoved := JSONArrayOdpovede.Items[I] as TJSONObject;
              SurovePismeno := JSONOdpoved.Get('pismeno_odpovede').JsonValue.Value;
              SurovyTextOdpovede := JSONOdpoved.Get('text_odpovede').JsonValue.Value;
              // 🚀 Uložíme si skutočné písmeno odpovede pre daný index riadku
              FPismenaPozicii[I] := SurovePismeno;
              // Do Tagu priradíme čisté Pascal číslo indexu (0 až 7)


case I of
  0: begin chkA.Tag := 0; chkA.Visible := True; PriradOdpoved(lblA, IDOtazky, SurovePismeno, SurovyTextOdpovede); lblA.Visible := True; end;
  1: begin chkB.Tag := 1; chkB.Visible := True; PriradOdpoved(lblB, IDOtazky, SurovePismeno, SurovyTextOdpovede); lblB.Visible := True; end;
  2: begin chkC.Tag := 2; chkC.Visible := True; PriradOdpoved(lblC, IDOtazky, SurovePismeno, SurovyTextOdpovede); lblC.Visible := True; end;
  3: begin chkD.Tag := 3; chkD.Visible := True; PriradOdpoved(lblD, IDOtazky, SurovePismeno, SurovyTextOdpovede); lblD.Visible := True; end;
  4: begin chkE.Tag := 4; chkE.Visible := True; PriradOdpoved(lblE, IDOtazky, SurovePismeno, SurovyTextOdpovede); lblE.Visible := True; end;
  5: begin chkF.Tag := 5; chkF.Visible := True; PriradOdpoved(lblF, IDOtazky, SurovePismeno, SurovyTextOdpovede); lblF.Visible := True; end;
  6: begin chkG.Tag := 6; chkG.Visible := True; PriradOdpoved(lblG, IDOtazky, SurovePismeno, SurovyTextOdpovede); lblG.Visible := True; end;
  7: begin chkH.Tag := 7; chkH.Visible := True; PriradOdpoved(lblH, IDOtazky, SurovePismeno, SurovyTextOdpovede); lblH.Visible := True; end;
end;




          // 🚀 TU SPUSTÍME PREPÍNANIE TLAČIDIEL PRE POSLEDNÚ OTÁZKU SÚSTAVY:
          if FAktualnePoradie = FMaxOtazok then
          begin
            btnDalsia.Caption := 'Dokončiť test';
            btnUkoncit.Visible := False; // Skryjeme tlačidlo pre prerušenie
          end
          else
          begin
            btnDalsia.Caption := 'Ďalšia otázka';
            btnUkoncit.Visible := True;  // Na všetkých predošlých otázkach svieti
          end;


            end;
          end
          else
//            ShowMessage('⚠️ CHYBA: Pole "odpovede" je v Pascale NULL!');
        end
        else
//          ShowMessage('⚠️ CHYBA: Hlavný JSON objekt sa nepodarilo naparsovať (NULL)!');
      finally
        JSONRes.Free;
      end;
    end;
  finally
    wr.Free;
  end;
end;




procedure TfStudentTest.btnDalsiaClick(Sender: TObject); async;
var
  wr: THttpRequest;
  res: TJSXMLHttpRequest;
  OznaceneOdpovede, PayloadText, CistyJsonText: string;
  JSONRes: TJSONObject;
  TotalCelkom, TotalZodpovedane, TotalBody, TotalPercenta: string;
  JeMensi: Boolean;
begin
  // 🚀 FIX: TU UŽ NIE JE ŽIADNE chkA.Checked := False A PODOBNÉ KOKOTINY!
  // Pamäť prehliadača zostane čistá a tvoj odladený OtvorTest všetko zvládne sám.
  // 1. KROK: Zozbierame skutočné pôvodné písmená z označených checkboxov (z ElementID)
  // 1. KROK: Zozbierame skutočné náhodne pomiešané písmená z označených checkboxov podľa tvojho Tag systému
  OznaceneOdpovede := '';
  if chkA.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[0] + ',';
  if chkB.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[1] + ',';
  if chkC.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[2] + ',';
  if chkD.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[3] + ',';
  if chkE.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[4] + ',';
  if chkF.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[5] + ',';
  if chkG.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[6] + ',';
  if chkH.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[7] + ',';

  // 2. KROK: Poskladáme JSON payload pre serverový endpoint /ulozodpoved
  PayloadText := '{"TEST_ID":' + IntToStr(FTestID) +
                 ',"PORADIE":' + IntToStr(FAktualnePoradie) +
                 ',"oznacene_odpovede":"' + OznaceneOdpovede + '"}';
  wr := THttpRequest.Create(nil);
  try
    wr.Command := httpPOST;
    wr.URL := 'http://' + window.location.hostname + ':8080/ulozodpoved';
    asm
      var utf8Bytes = encodeURIComponent(PayloadText).replace(/%([0-9A-F]{2})/g, function(match, p1) { return String.fromCharCode('0x' + p1); });
      wr.FPostData = btoa(utf8Bytes);
    end;
    res := await(TJSXMLHttpRequest, wr.Perform);
    if (res <> nil) and (res.responseText = 'OK') then
    begin
      JeMensi := False;
      // Striktné číselné porovnanie v JS bez konfliktných zátvoriek
      asm
        if (parseInt(this.FAktualnePoradie) < parseInt(this.FMaxOtazok)) JeMensi = true;
      end;
      // 3. KROK: Ak nie sme na konci, skočíme do tvojho dokonalého OtvorTest
      if JeMensi then
      begin
        OtvorTest(FTestID, FAktualnePoradie + 1);
      end
      else
      begin
        // Sme na úplnom konci poslednej otázky -> automaticky uzavrieme test ako 'Dokonceny'
        PayloadText := '{"TEST_ID":' + IntToStr(FTestID) + ',"STAV":"Dokonceny"}';
        wr.URL := 'http://' + window.location.hostname + ':8080/uzavrietest';
        asm
          var utf8BytesFin = encodeURIComponent(PayloadText).replace(/%([0-9A-F]{2})/g, function(match, p1) { return String.fromCharCode('0x' + p1); });
          wr.FPostData = btoa(utf8BytesFin);
        end;
        res := await(TJSXMLHttpRequest, wr.Perform);
        if (res <> nil) and (res.responseText <> '') then
        begin
          asm
            var cleanResponse = res.responseText.replace(/[\r\n\s]/g, '');
            var binaryString = atob(cleanResponse);
            var bytes = new Uint8Array(binaryString.length);
            for (var i = 0; i < binaryString.length; i++) bytes[i] = binaryString.charCodeAt(i);
            var decoder = new TextDecoder('utf-8');
            CistyJsonText = decoder.decode(bytes);
          end;
          JSONRes := TJSONObject.ParseJSONValue(CistyJsonText) as TJSONObject;
          try
            if JSONRes <> nil then
            begin
              TotalCelkom := JSONRes.GetJSONValue('celkom');
              TotalZodpovedane := JSONRes.GetJSONValue('zodpovedane');
              TotalBody := JSONRes.GetJSONValue('body');
              TotalPercenta := JSONRes.GetJSONValue('percenta');
              if TotalCelkom = '' then TotalCelkom := JSONRes.Get('celkom').JsonValue.Value;
              if TotalZodpovedane = '' then TotalZodpovedane := JSONRes.Get('zodpovedane').JsonValue.Value;
              if TotalBody = '' then TotalBody := JSONRes.Get('body').JsonValue.Value;
              if TotalPercenta = '' then TotalPercenta := JSONRes.Get('percenta').JsonValue.Value;
              Self.Visible := False;
              fVysledkyTestu := TfVysledkyTestu.Create(Self);
              try
                fVysledkyTestu.Popup := False; fVysledkyTestu.Border := fbNone;
                await(TfVysledkyTestu, fVysledkyTestu.Load);
                fVysledkyTestu.NacitajVysledky(FTestID);
                await(TModalResult, fVysledkyTestu.Execute);
              finally

                textChyb := fVysledkyTestu.btnZavriet.Hint;
                fVysledkyTestu.Free;
              end;
              ModalResult := mrOk;
            end;
          finally
            JSONRes.Free;
          end;
        end;
      end;
    end
    else
    begin
      ShowMessage('Chyba: Nepodarilo sa uložiť odpoveď na server.');
    end;
  finally
    wr.Free;
  end;
end;



procedure TfStudentTest.btnUkoncitClick(Sender: TObject);
begin
  MessageDlg('Naozaj chcete test predčasne ukončiť a vyhodnotiť doterajšie odpovede?',
    mtConfirmation, [mbYes, mbNo],
    procedure(AValue: Integer)
    begin
      if AValue = mrYes then
      begin
        ZavriTestNaPozadi; // Bezpečne odpáli uloženie a zatvorenie na pozadí
      end;
    end
  );
end;


procedure TfStudentTest.btnZavrietClick(Sender: TObject);
begin
ModalResult := mrOk;
end;

procedure TfStudentTest.NaplnCheckBox(ACheckBox: TCheckBox; AData: TJSONObject);
var
  TextOdpovede, Pismeno: string;
begin
  TextOdpovede := '';
  Pismeno := '';
  // ⚡ Absolútne priamy prístup k JS vlastnostiam prinesie čistý text
  asm
    if (AData) {
      // Vytiahneme hodnotu bez ohľadu na to, či je to zabalené v páre alebo surové
      TextOdpovede = AData.text_odpovede || (AData.FJSObject ? AData.FJSObject.text_odpovede : '');
      Pismeno = AData.pismeno_odpovede || (AData.FJSObject ? AData.FJSObject.pismeno_odpovede : '');
      // Ak je to TMS JSON štruktúra, prečítame surovú hodnotu priamo z FValue
      if (!TextOdpovede && AData.Values && AData.Values['text_odpovede']) {
        TextOdpovede = AData.Values['text_odpovede'].FValue;
      }
      if (!Pismeno && AData.Values && AData.Values['pismeno_odpovede']) {
        Pismeno = AData.Values['pismeno_odpovede'].FValue;
      }
    }
  end;
  // Bezpečne priradíme ako obyčajný text bez HTML formátovania pre absolútnu stabilitu
  ACheckBox.Caption := TextOdpovede;
  ACheckBox.ElementID := Pismeno;
  ACheckBox.Visible := True;
  ACheckBox.Checked := False;
end;





procedure TfStudentTest.VycistiOdpovedovePole;
begin
  chkA.Checked := False; chkA.Visible := False; lblA.html.Text := ''; lblA.Visible := False;
  chkB.Checked := False; chkB.Visible := False; lblB.html.Text := ''; lblB.Visible := False;
  chkC.Checked := False; chkC.Visible := False; lblC.html.Text := ''; lblC.Visible := False;
  chkD.Checked := False; chkD.Visible := False; lblD.html.Text := ''; lblD.Visible := False;
  chkE.Checked := False; chkE.Visible := False; lblE.html.Text := ''; lblE.Visible := False;
  chkF.Checked := False; chkF.Visible := False; lblF.html.Text := ''; lblF.Visible := False;
  chkG.Checked := False; chkG.Visible := False; lblG.html.Text := ''; lblG.Visible := False;
  chkH.Checked := False; chkH.Visible := False; lblH.html.Text := ''; lblH.Visible := False;
end;

procedure TfStudentTest.ZavriTestNaPozadi; async;
var
  wr: THttpRequest;
  res: TJSXMLHttpRequest;
  OznaceneOdpovede, PayloadText, CistyJsonText: string;
  JSONRes: TJSONObject;
begin
  // 1. KROK: Najprv rýchlo zozbierame a odošleme aktuálne začiarknuté checkboxy z ElementID
  // 1. KROK: Zozbierame skutočné náhodne pomiešané písmená z označených checkboxov podľa tvojho Tag systému
  OznaceneOdpovede := '';
  if chkA.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[0] + ',';
  if chkB.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[1] + ',';
  if chkC.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[2] + ',';
  if chkD.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[3] + ',';
  if chkE.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[4] + ',';
  if chkF.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[5] + ',';
  if chkG.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[6] + ',';
  if chkH.Checked then OznaceneOdpovede := OznaceneOdpovede + FPismenaPozicii[7] + ',';
  PayloadText := '{"TEST_ID":' + IntToStr(FTestID) +
                 ',"PORADIE":' + IntToStr(FAktualnePoradie) +
                 ',"oznacene_odpovede":"' + OznaceneOdpovede + '"}';
  wr := THttpRequest.Create(nil);
  try
    wr.Command := httpPOST;
    wr.URL := 'http://' + window.location.hostname + ':8080/ulozodpoved';
    asm
      var utf8Bytes = encodeURIComponent(PayloadText).replace(/%([0-9A-F]{2})/g, function(match, p1) { return String.fromCharCode('0x' + p1); });
      wr.FPostData = btoa(utf8Bytes);
    end;
    await(TJSXMLHttpRequest, wr.Perform);
  finally
    wr.Free;
  end;
  // 2. KROK: Odošleme požiadavku na uzatvorenie celého testu so stavom 'Preruseny'
  PayloadText := '{"TEST_ID":' + IntToStr(FTestID) + ',"STAV":"Preruseny"}';
  wr := THttpRequest.Create(nil);
  try
    wr.Command := httpPOST;
    wr.URL := 'http://' + window.location.hostname + ':8080/uzavrietest';
    asm
      var utf8BytesFin = encodeURIComponent(PayloadText).replace(/%([0-9A-F]{2})/g, function(match, p1) { return String.fromCharCode('0x' + p1); });
      wr.FPostData = btoa(utf8BytesFin);
    end;
    res := await(TJSXMLHttpRequest, wr.Perform);
    if (res <> nil) and (res.responseText <> '') then
    begin
      // 🔓 Dešifrovanie z Base64 do čistého slovenského UTF-8 reťazca
      asm
        var cleanResponse = res.responseText.replace(/[\r\n\s]/g, '');
        var binaryString = atob(cleanResponse);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) bytes[i] = binaryString.charCodeAt(i);
        var decoder = new TextDecoder('utf-8');
        CistyJsonText = decoder.decode(bytes);
      end;
      JSONRes := TJSONObject.ParseJSONValue(CistyJsonText) as TJSONObject;
      try
        if JSONRes <> nil then
        begin
          // Skryjeme aktuálne formulár testu pred otvorením okna výsledkov
          Self.Visible := False;
          // 🚀 3. KROK: DYNAMIC-KÉ A ASYNCHRÓNNE OTVORENIE OKNA VŠETKÝCH OTÁZOK
          fVysledkyTestu := TfVysledkyTestu.Create(Self);
          try
            fVysledkyTestu.Popup := False;
            fVysledkyTestu.Border := fbNone;
            // Načítame HTML šablónu formulára výsledkov
            await(TfVysledkyTestu, fVysledkyTestu.Load);
            // Odpálime dopyt na endpoint /vytiahnivysledky pre stiahnutie všetkých riadkov
            fVysledkyTestu.NacitajVysledky(FTestID);
            // Spustíme asynchrónne modálne zobrazenie okna výsledkov
            await(TModalResult, fVysledkyTestu.Execute);
          finally
            textChyb := fVysledkyTestu.btnZavriet.Hint;
            fVysledkyTestu.Free; // Po zavretí kompletne uvoľníme pamäť webu
          end;
          ModalResult := mrCancel; // Vráti študenta plynule do hlavného menu
        end;
      finally
        JSONRes.Free;
      end;
    end;
  finally
    wr.Free;
  end;
end;



procedure TfStudentTest.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblInfo := TLabel.Create(Self);
  pbProgress := TProgressBar.Create(Self);
  chkA := TCheckBox.Create(Self);
  chkB := TCheckBox.Create(Self);
  chkC := TCheckBox.Create(Self);
  chkD := TCheckBox.Create(Self);
  chkE := TCheckBox.Create(Self);
  chkF := TCheckBox.Create(Self);
  chkG := TCheckBox.Create(Self);
  chkH := TCheckBox.Create(Self);
  btnUkoncit := TSpeedButton.Create(Self);
  btnDalsia := TSpeedButton.Create(Self);
  btnZavriet := TSpeedButton.Create(Self);
  lblA := THTMLDiv.Create(Self);
  lblB := THTMLDiv.Create(Self);
  lblC := THTMLDiv.Create(Self);
  lblD := THTMLDiv.Create(Self);
  lblE := THTMLDiv.Create(Self);
  lblF := THTMLDiv.Create(Self);
  lblG := THTMLDiv.Create(Self);
  lblH := THTMLDiv.Create(Self);
  memOtazka := THTMLDiv.Create(Self);

  lblInfo.BeforeLoadDFMValues;
  pbProgress.BeforeLoadDFMValues;
  chkA.BeforeLoadDFMValues;
  chkB.BeforeLoadDFMValues;
  chkC.BeforeLoadDFMValues;
  chkD.BeforeLoadDFMValues;
  chkE.BeforeLoadDFMValues;
  chkF.BeforeLoadDFMValues;
  chkG.BeforeLoadDFMValues;
  chkH.BeforeLoadDFMValues;
  btnUkoncit.BeforeLoadDFMValues;
  btnDalsia.BeforeLoadDFMValues;
  btnZavriet.BeforeLoadDFMValues;
  lblA.BeforeLoadDFMValues;
  lblB.BeforeLoadDFMValues;
  lblC.BeforeLoadDFMValues;
  lblD.BeforeLoadDFMValues;
  lblE.BeforeLoadDFMValues;
  lblF.BeforeLoadDFMValues;
  lblG.BeforeLoadDFMValues;
  lblH.BeforeLoadDFMValues;
  memOtazka.BeforeLoadDFMValues;
  try
    Name := 'fStudentTest';
    Width := 914;
    Height := 938;
    lblInfo.SetParentComponent(Self);
    lblInfo.Name := 'lblInfo';
    lblInfo.Left := 40;
    lblInfo.Top := 48;
    lblInfo.Width := 34;
    lblInfo.Height := 15;
    lblInfo.Caption := 'lblInfo';
    lblInfo.HeightPercent := 100.000000000000000000;
    lblInfo.WidthPercent := 100.000000000000000000;
    pbProgress.SetParentComponent(Self);
    pbProgress.Name := 'pbProgress';
    pbProgress.Left := 40;
    pbProgress.Top := 80;
    pbProgress.Width := 300;
    pbProgress.Height := 24;
    pbProgress.ChildOrder := 1;
    chkA.SetParentComponent(Self);
    chkA.Name := 'chkA';
    chkA.Left := 56;
    chkA.Top := 259;
    chkA.Width := 25;
    chkA.Height := 22;
    chkA.ChildOrder := 3;
    chkA.HeightPercent := 100.000000000000000000;
    chkA.WidthPercent := 100.000000000000000000;
    chkB.SetParentComponent(Self);
    chkB.Name := 'chkB';
    chkB.Left := 56;
    chkB.Top := 345;
    chkB.Width := 25;
    chkB.Height := 22;
    chkB.ChildOrder := 3;
    chkB.HeightPercent := 100.000000000000000000;
    chkB.WidthPercent := 100.000000000000000000;
    chkC.SetParentComponent(Self);
    chkC.Name := 'chkC';
    chkC.Left := 56;
    chkC.Top := 432;
    chkC.Width := 25;
    chkC.Height := 22;
    chkC.ChildOrder := 3;
    chkC.HeightPercent := 100.000000000000000000;
    chkC.WidthPercent := 100.000000000000000000;
    chkD.SetParentComponent(Self);
    chkD.Name := 'chkD';
    chkD.Left := 56;
    chkD.Top := 518;
    chkD.Width := 25;
    chkD.Height := 22;
    chkD.ChildOrder := 3;
    chkD.HeightPercent := 100.000000000000000000;
    chkD.WidthPercent := 100.000000000000000000;
    chkE.SetParentComponent(Self);
    chkE.Name := 'chkE';
    chkE.Left := 56;
    chkE.Top := 605;
    chkE.Width := 25;
    chkE.Height := 22;
    chkE.ChildOrder := 3;
    chkE.HeightPercent := 100.000000000000000000;
    chkE.WidthPercent := 100.000000000000000000;
    chkF.SetParentComponent(Self);
    chkF.Name := 'chkF';
    chkF.Left := 56;
    chkF.Top := 691;
    chkF.Width := 25;
    chkF.Height := 22;
    chkF.ChildOrder := 3;
    chkF.HeightPercent := 100.000000000000000000;
    chkF.WidthPercent := 100.000000000000000000;
    chkG.SetParentComponent(Self);
    chkG.Name := 'chkG';
    chkG.Left := 56;
    chkG.Top := 778;
    chkG.Width := 25;
    chkG.Height := 22;
    chkG.ChildOrder := 3;
    chkG.HeightPercent := 100.000000000000000000;
    chkG.WidthPercent := 100.000000000000000000;
    chkH.SetParentComponent(Self);
    chkH.Name := 'chkH';
    chkH.Left := 56;
    chkH.Top := 865;
    chkH.Width := 25;
    chkH.Height := 22;
    chkH.ChildOrder := 3;
    chkH.HeightPercent := 100.000000000000000000;
    chkH.WidthPercent := 100.000000000000000000;
    btnUkoncit.SetParentComponent(Self);
    btnUkoncit.Name := 'btnUkoncit';
    btnUkoncit.Left := 590;
    btnUkoncit.Top := 80;
    btnUkoncit.Width := 121;
    btnUkoncit.Height := 24;
    btnUkoncit.Caption := 'Ukon'#269'i'#357;
    btnUkoncit.Color := clNone;
    btnUkoncit.HeightPercent := 100.000000000000000000;
    btnUkoncit.TabOrder := 9;
    btnUkoncit.WidthPercent := 100.000000000000000000;
    SetEvent(btnUkoncit, Self, 'OnClick', 'btnUkoncitClick');
    btnDalsia.SetParentComponent(Self);
    btnDalsia.Name := 'btnDalsia';
    btnDalsia.Left := 366;
    btnDalsia.Top := 80;
    btnDalsia.Width := 121;
    btnDalsia.Height := 24;
    btnDalsia.Caption := #270'al'#353'ia ot'#225'zka';
    btnDalsia.Color := clNone;
    btnDalsia.HeightPercent := 100.000000000000000000;
    btnDalsia.TabOrder := 10;
    btnDalsia.WidthPercent := 100.000000000000000000;
    SetEvent(btnDalsia, Self, 'OnClick', 'btnDalsiaClick');
    btnZavriet.SetParentComponent(Self);
    btnZavriet.Name := 'btnZavriet';
    btnZavriet.Left := 752;
    btnZavriet.Top := 80;
    btnZavriet.Width := 121;
    btnZavriet.Height := 24;
    btnZavriet.Caption := 'Zavrie'#357;
    btnZavriet.Color := clNone;
    btnZavriet.HeightPercent := 100.000000000000000000;
    btnZavriet.TabOrder := 11;
    btnZavriet.WidthPercent := 100.000000000000000000;
    SetEvent(btnZavriet, Self, 'OnClick', 'btnZavrietClick');
    lblA.SetParentComponent(Self);
    lblA.Name := 'lblA';
    lblA.Left := 112;
    lblA.Top := 259;
    lblA.Width := 758;
    lblA.Height := 85;
    lblA.ChildOrder := 22;
    lblA.Role := '';
    lblB.SetParentComponent(Self);
    lblB.Name := 'lblB';
    lblB.Left := 112;
    lblB.Top := 346;
    lblB.Width := 758;
    lblB.Height := 85;
    lblB.ChildOrder := 22;
    lblB.Role := '';
    lblC.SetParentComponent(Self);
    lblC.Name := 'lblC';
    lblC.Left := 112;
    lblC.Top := 432;
    lblC.Width := 758;
    lblC.Height := 85;
    lblC.ChildOrder := 22;
    lblC.Role := '';
    lblD.SetParentComponent(Self);
    lblD.Name := 'lblD';
    lblD.Left := 112;
    lblD.Top := 519;
    lblD.Width := 758;
    lblD.Height := 85;
    lblD.ChildOrder := 22;
    lblD.Role := '';
    lblE.SetParentComponent(Self);
    lblE.Name := 'lblE';
    lblE.Left := 112;
    lblE.Top := 605;
    lblE.Width := 758;
    lblE.Height := 86;
    lblE.ChildOrder := 22;
    lblE.Role := '';
    lblF.SetParentComponent(Self);
    lblF.Name := 'lblF';
    lblF.Left := 112;
    lblF.Top := 692;
    lblF.Width := 758;
    lblF.Height := 85;
    lblF.ChildOrder := 22;
    lblF.Role := '';
    lblG.SetParentComponent(Self);
    lblG.Name := 'lblG';
    lblG.Left := 112;
    lblG.Top := 778;
    lblG.Width := 758;
    lblG.Height := 86;
    lblG.ChildOrder := 22;
    lblG.Role := '';
    lblH.SetParentComponent(Self);
    lblH.Name := 'lblH';
    lblH.Left := 112;
    lblH.Top := 865;
    lblH.Width := 758;
    lblH.Height := 77;
    lblH.ChildOrder := 22;
    lblH.Role := '';
    memOtazka.SetParentComponent(Self);
    memOtazka.Name := 'memOtazka';
    memOtazka.Left := 40;
    memOtazka.Top := 120;
    memOtazka.Width := 830;
    memOtazka.Height := 125;
    memOtazka.ChildOrder := 22;
    memOtazka.Role := '';
  finally
    lblInfo.AfterLoadDFMValues;
    pbProgress.AfterLoadDFMValues;
    chkA.AfterLoadDFMValues;
    chkB.AfterLoadDFMValues;
    chkC.AfterLoadDFMValues;
    chkD.AfterLoadDFMValues;
    chkE.AfterLoadDFMValues;
    chkF.AfterLoadDFMValues;
    chkG.AfterLoadDFMValues;
    chkH.AfterLoadDFMValues;
    btnUkoncit.AfterLoadDFMValues;
    btnDalsia.AfterLoadDFMValues;
    btnZavriet.AfterLoadDFMValues;
    lblA.AfterLoadDFMValues;
    lblB.AfterLoadDFMValues;
    lblC.AfterLoadDFMValues;
    lblD.AfterLoadDFMValues;
    lblE.AfterLoadDFMValues;
    lblF.AfterLoadDFMValues;
    lblG.AfterLoadDFMValues;
    lblH.AfterLoadDFMValues;
    memOtazka.AfterLoadDFMValues;
  end;
end;

end.